export const getLocalizedContent = <T extends { locale: string }>(
  locale: string,
  data: Array<T>,
) => {
  return data.find((t) => t.locale === locale) ?? data[0];
};
